import { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, Typography, makeStyles } from '@material-ui/core';
import TouchRipple from '@material-ui/core/ButtonBase/TouchRipple';
import ActionButton from '../../actionButton';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-blue.svg';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginLeft: spacing(4),
  },
  label: {
    lineHeight: '24px',
    marginRight: spacing(2),
  },
  clearFiltersWrapper: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 4,
    padding: spacing(1),
    marginLeft: spacing(-1),
    userSelect: 'none',
    position: 'relative',
  },
  clearFiltersLabel: {
    color: primary.blue1,
  },
  touchRipple: {
    backgroundColor: primary.blue1,
  },
  collapseButton: {
    width: 24,
    height: 24,
    marginLeft: spacing(2),
  },
  expandIcon: {
    transform: 'rotate(0deg)',
    transition: 'transform .3s cubic-bezier(0.77, 0.2, 0.05, 1)',
    width: 12,
    height: 12,
  },
  expandIconOpened: {
    transform: 'rotate(180deg)',
  },
}));

const SelectedFiltersActions = ({
  translations,
  hasSelectedFilters,
  isExpanded,
  isDisabled,
  onClear,
  onSelect,
}) => {
  const classes = useStyles();
  const touchRippleRef = useRef(null);

  const onRippleStart = e => {
    touchRippleRef?.current?.start(e);
  };

  const onRippleStop = e => {
    touchRippleRef?.current?.stop(e);
  };

  return (
    <div className={classes.root}>
      <Fade in={hasSelectedFilters || isDisabled} unmountOnExit>
        <>
          <div
            className={classes.clearFiltersWrapper}
            onMouseDown={onRippleStart}
            onMouseUp={onRippleStop}
            onClick={onClear}
          >
            <Typography
              className={classNames(classes.label, classes.clearFiltersLabel)}
              variant="subtitle2"
            >
              {translations.clearAll}
            </Typography>
            <CloseIcon />
            <TouchRipple
              ref={touchRippleRef}
              classes={{ child: classes.touchRipple }}
            />
          </div>
          {hasSelectedFilters && (
            <ActionButton
              className={classes.collapseButton}
              iconClass={classNames(classes.expandIcon, {
                [classes.expandIconOpened]: isExpanded,
              })}
              type={ACTION_BUTTON_TYPES.ARROW}
              size="small"
              onClickHandler={onSelect}
            />
          )}
        </>
      </Fade>
    </div>
  );
};

SelectedFiltersActions.propTypes = {
  translations: PropTypes.object.isRequired,
  hasSelectedFilters: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default SelectedFiltersActions;
